<template>
  <SuggestionsPicker
    v-model="model"
    :models.sync="companiesModel"
    :action="action"
    :autoload="false"
    :multiple="multiple"
    :disabled="disabled"
    placeholder="Выберите компанию"
    :min-query-length="3"
  />
</template>

<script>
  import { CareerSuggestionsResource } from 'src/services/suggestions.js';
  import { createPropModel, modelValueConfig } from 'src/utils/vue.js';

  import SuggestionsPicker from 'src/components/suggestions/SuggestionsPicker/SuggestionsPicker.vue';

  export default {
    name: 'CompanyPicker',
    components: { SuggestionsPicker },
    model: modelValueConfig(),
    props: {
      modelValue: [Number, Array],
      companies: Array,
      multiple: Boolean,
      disabled: Boolean,
    },
    methods: {
      action: CareerSuggestionsResource.getCompanies,
    },
    computed: {
      model: createPropModel('modelValue'),
      companiesModel: createPropModel('companies'),
    }
  }
</script>